import React from 'react'
import Link from 'gatsby-link'

import './footer.css'

export default () => {
  return (
    <footer className="app-landing__footer">
      <div className="footer-content">
        <ul className="footer-nav">
          <li>&copy; 2018 LeanLoop Ltd.</li>
          <li>
            <Link to="/privacy">privacy policy</Link>
          </li>
          <li>
            <Link to="/terms">terms and conditions</Link>
          </li>
        </ul>
      </div>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/footer.js